import { render, staticRenderFns } from "./addApproved.vue?vue&type=template&id=58971420&scoped=true&name=addApproved&"
import script from "./addApproved.vue?vue&type=script&lang=js&"
export * from "./addApproved.vue?vue&type=script&lang=js&"
import style0 from "./addApproved.vue?vue&type=style&index=0&id=58971420&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58971420",
  null
  
)

export default component.exports